
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#3A4249","d":"M35.466 14.965L25.893 1.422l-5.638 2.052 5.472 15.035zM10.881 23.912l-5.743-6.423-3.759 1.368 2.736 7.518zM62.379 16.874c-.726-1.997-2.878-3.046-4.889-2.451l-5.875 2.113-.684-1.88 4.153-1.493-1.657-1.009a4 4 0 00-3.449-.342L4.799 28.254l2.052 5.638 21.188-.263 2.819-1.026 5.814 15.975 5.639-2.052-1.458-17.56 19.135-6.964a4 4 0 002.391-5.128zm-23.665 2.229l.684 1.879-1.879.684-.684-1.879 1.879-.684zm-3.759 1.368l.684 1.879-1.879.684-.684-1.879 1.879-.684zm-3.759 1.368l.684 1.879-1.879.684-.684-1.879 1.879-.684zm-16.229 8.036l-.685-1.879 1.879-.685.685 1.879-1.879.685zm3.759-1.369l-.685-1.879 1.879-.685.685 1.879-1.879.685zm3.757-1.368l-.683-1.879 1.879-.684.684 1.879-1.88.684zm3.759-1.368l-.684-1.879 1.879-.684.684 1.879-1.879.684zm15.035-5.473l-.684-1.879 1.879-.684.684 1.879-1.879.684zm3.759-1.368l-.684-1.879 1.879-.684.684 1.879-1.879.684z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M19 54h17v-2H19c-2.206 0-4-1.794-4-4s1.794-4 4-4h6.184A2.994 2.994 0 0028 46a3.001 3.001 0 000-6 2.992 2.992 0 00-2.816 2H19c-3.309 0-6 2.691-6 6s2.691 6 6 6zM38 52h2v2h-2z"}}),_c('path',{attrs:{"fill":"#3A4249","d":"M50.5 52H42v2h8.5c1.379 0 2.5 1.122 2.5 2.5S51.879 59 50.5 59H19v2h31.5c2.481 0 4.5-2.019 4.5-4.5S52.981 52 50.5 52zM5 57a3.001 3.001 0 000 6 2.992 2.992 0 002.816-2H17v-2H7.816A2.992 2.992 0 005 57z"}})])
          )
        }
      }
    